<template>
  <div v-if="selectedCliente">
    <b-overlay
      :show="spinner"
      spinner-variant="primary"
    >
      <b-card>
        <clientesForm
          clienteSubmit="Crear Cliente"
          :cliente="selectedCliente"
          @processCliente="agregarCliente"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>

import { BCard, BOverlay } from 'bootstrap-vue'
import { mapActions, mapState } from 'vuex'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const clientesForm = () => import('@/layouts/components/Clientes/ClientesForm.vue')

export default {
  components: {
    BCard,
    BOverlay,
    clientesForm,
  },
  data() {
    return {
      spinner: false,
    }
  },
  computed: {
    ...mapState('clientes', ['selectedCliente']),
  },
  created() {
    // Consultar autenticación del
    // console.log(this.selectedCliente)
  },
  methods: {
    ...mapActions({ createCliente: 'clientes/addClientes' }),
    agregarCliente(cliente) {
      this.spinner = true
      this.createCliente(cliente).then(() => {
        const errorClientes = store.state.clientes
        const errorMessage = errorClientes.errorMessage.errors
        if (!errorClientes.error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente creado con éxito 👍',
              icon: 'CheckIcon',
              text: `El cliente "${cliente.nombre}" fue creado con éxito!`,
              variant: 'success',
            },
          },
          {
            timeout: 4000,
          })
          this.$router.replace({
            name: 'clientes',
          })
        } else if (errorMessage.rut) {
          this.$swal({
            title: 'Error!',
            text: `${errorMessage.rut[0]}!`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        } else {
          this.$swal({
            title: 'Error!',
            text: 'Ingreso de datos fraudulento!',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        }
        this.spinner = false
      })
    },
  },
}
</script>
